import React from "react";
import "./loader.css";

export const Loader = () => {
  return (
    <div className="loader">
      <span className="loader__element"></span>
      <span className="loader__element"></span>
      <span className="loader__element"></span>
    </div>
  );
};
